import React from 'react';
import { connect } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { TpaSettingsProvider } from '@wix/tpa-settings/dist/src/contexts';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import i18n from '../i18n';
import RauterApp from './rauter';
import withEnhancedStyleLoader from '../components/hoc/withEnhancedStyleLoader/withEnhancedStyleLoader';

import { useStyles } from '@wix/tpa-settings/dist/src/hooks';
import { instagramStyleParams } from '../settings';
import { DIRECTIONS } from '../constants/settingsConstants';

// Actions
import { isMobile } from '../actions/more/utils';
import { getLocaleById } from '../actions/more/langHelperFunctions';

import './app.scss';

const AppWithLocale = ({ mobile, isRtl }) => {
  const styles = useStyles();
  const langPicker = styles.get(instagramStyleParams.langPicker);
  const locale =
    typeof langPicker === 'number' ? getLocaleById(langPicker) : 'en';

  return (
    <TPAComponentsProvider value={{ mobile, rtl: isRtl }}>
      <I18nextProvider i18n={i18n(locale)}>
        <RauterApp locale={locale} isMobile={mobile} isRtl={isRtl} />
      </I18nextProvider>
    </TPAComponentsProvider>
  );
};

const App = ({ direction }) => {
  const mobile = isMobile();
  const isRtl = direction === DIRECTIONS.RTL;
  return (
    <TpaSettingsProvider Wix={window.Wix}>
      <AppWithLocale mobile={mobile} isRtl={isRtl} />
    </TpaSettingsProvider>
  );
};

const mapStateToProps = (state) => ({
  direction: state.settingsReducer.direction,
  overlayEffect: state.settingsReducer.overlayEffect,
});

export default connect(mapStateToProps, null)(withEnhancedStyleLoader(App));
